import React from 'react';
import PropTypes from 'prop-types';
import './Result.scss';
import { getInitialState, repeatQuiz } from '../quizSlice.js';
import { setPreviousModule, getInitialStateWithPreviousView, showView, setSelectedModulePrevious } from '../../../Menu/MenuSide/menuSideSlice';
import {addQuizResult } from '../../../Authorization/authSlice';


function Result(props) {
   // console.log(props.quizRedux)
    const { dispatch } = props;
   const onClickEnd = () => {
    
        
        dispatch(getInitialStateWithPreviousView());
        dispatch(setSelectedModulePrevious());
        dispatch(setPreviousModule());
        
        dispatch(getInitialState());
        dispatch(showView(props.previousModule));

        const item = {
            user_id:props.userId,
            //quiz_id:props.quizRedux.dataQuiz[0].quiz_id,
            quiz_id: Number(props.quizRedux.dataQuestionsResult[0][3]),
            quiz_resolved: (props.trueAnswer/props.questionTotal)*100,
            dataQuestionsResult: props.quizRedux.dataQuestionsResult,
        }
        dispatch(addQuizResult(item));
//check if quiz incledes in  finished quizes
/*
        const finishedQuizCheck = props.finishedQuizes.map(item => {
             if (item.quiz_id === props.quizRedux.dataQuiz[0].quiz_id) {
                   // console.log(item.quiz_id );
                   // console.log(props.quizRedux.dataQuiz[0].quiz_id);

                    return true;
                } else return false;
        })
        //console.log(finishedQuizCheck);
        const resultFinishedQuiz = finishedQuizCheck.includes(true);cd

        if (item.quiz_resolved === 100 && !resultFinishedQuiz) {
               dispatch(addUserScore(item));
        }
*/

        //name quiz






   };

   const onClickRepeat =() => {
       const { dispatch } = props;
       dispatch(repeatQuiz());
   }

    return (
        <div className="Result">
            <div className="Quiz-header">
                      
                       <span>Результат</span>
                    
            </div>
            <div className="Result-body">
                <ul>
                    <li>Всего вопросов <span>{props.questionTotal}</span></li>
                    <li className='trueAnswers'>Правильных ответов <span>{props.trueAnswer}</span></li>
                    <li className='wrongAnswers'>Неправильных ответов <span>{props.questionTotal - props.trueAnswer }</span></li>
                    <li>Ваш результат <span>{Math.floor((props.trueAnswer/props.questionTotal)*100)}%</span></li>
                </ul>
                  
            </div>
            <div className="Result-buttons">
                <button onClick = {onClickEnd} disabled={props.quizRedux.mistakesOptionQuiz ? true : false}>Завершить</button>
                <button onClick = {onClickRepeat}>Повторить</button>
            </div>

        </div>

    )
}

Result.propTypes = {
    quizResult: PropTypes.string.isRequired,
}
export default Result;